var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "19",
        viewBox: "0 0 17 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M14.7094 6.06924C15.9504 5.77744 16.875 4.66299 16.875 3.33057C16.875 1.77666 15.6164 0.518066 14.0625 0.518066C12.5367 0.518066 11.2957 1.73096 11.25 3.24268L4.78828 5.83018C4.27852 5.32744 3.58242 5.01807 2.8125 5.01807C1.25859 5.01807 0 6.27666 0 7.83057C0 9.38447 1.25859 10.6431 2.8125 10.6431C3.24141 10.6431 3.64922 10.5481 4.01133 10.3759L9.13008 14.8548C9.0457 15.122 9 15.4103 9 15.7056C9 17.2595 10.2586 18.5181 11.8125 18.5181C13.3664 18.5181 14.625 17.2595 14.625 15.7056C14.625 14.7317 14.1328 13.8739 13.3805 13.3712L14.7094 6.06924ZM5.49492 8.68135C5.57227 8.43877 5.61797 8.18213 5.625 7.91846L12.0867 5.33447C12.2133 5.45752 12.3469 5.57002 12.4945 5.66846L11.1656 12.9669C10.9723 13.0126 10.7859 13.0759 10.6102 13.1603L5.49492 8.68135Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }